import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { map, times } from 'lodash';
import { useTranslation } from 'react-i18next';

const CoverSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-5">
      <h2 className="text-center">{t('healthInsurancePage.coverSection.title')}</h2>
      <p className="text-center text-secondary w-75 mx-auto">{t('healthInsurancePage.coverSection.subTitle')}</p>
      <Container className="my-5">
        <Row className="gy-4">
          {map(times(8), (idx) => (
            <Col key={`coverItem${idx + 1}`} md={6} lg={4}>
              <Card className="h-100 bg-primary text-white text-md-center text-lg-start">
                <Card.Body>
                  <Card.Title className="text-center">
                    <h4 className="fw-bold">{t(`healthInsurancePage.coverSection.item${idx + 1}.label`)}</h4>
                  </Card.Title>
                  <Card.Text>{t(`healthInsurancePage.coverSection.item${idx + 1}.desc`)}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <p className="text-center text-secondary w-75 mx-auto">{t('healthInsurancePage.coverSection.notice')}</p>
    </section>
  );
};

export { CoverSection };
